import affiliateProgramTermsHtml from "../assets/Legal/AffiliateProgramTerms.md?html";
import { createRoute } from "../lib/createRoute";
import LegalMarkdown from "../pages/LegalMarkdown";

export const Route = createRoute(
  "/affiliate-program-terms",
  () => <LegalMarkdown htmlText={affiliateProgramTermsHtml} />,
  "Affiliate Program Terms | Flowstep",
  "The terms and conditions for Flowstep's affiliate program explain commission structure, payout rules, and partner responsibilities.",
);
